import { render, staticRenderFns } from "./UpdateItem.vue?vue&type=template&id=f405ec2e"
import script from "./UpdateItem.vue?vue&type=script&lang=js"
export * from "./UpdateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports